// Loaded lazily (only on pages that need it, only once) rather than in public/index.html.
export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

// Opens Razorpay checkout for an already-created order/request that returned a `razorpay`
// block, then verifies the signed response server-side via `verify`. The caller decides what
// happens next (clear a cart, show a confirmation screen, ...) inside `verify`/`onFail`.
export async function payWithRazorpay({ razorpay, description, prefill, verify, onDismiss, onFail }) {
  const loaded = await loadRazorpayScript();
  if (!loaded) {
    onFail?.("Could not load the payment gateway. Please try again.");
    return;
  }
  const rzp = new window.Razorpay({
    key: razorpay.key_id,
    order_id: razorpay.order_id,
    amount: razorpay.amount,
    currency: razorpay.currency,
    name: "YourPlants.in",
    description,
    prefill,
    theme: { color: "#1B4D3E" },
    handler: async (response) => {
      try {
        await verify({
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        });
      } catch (err) {
        onFail?.(err.message || "Payment verification failed");
      }
    },
    modal: { ondismiss: () => onDismiss?.() },
  });
  rzp.on("payment.failed", () => onFail?.("Payment failed. Please try again."));
  rzp.open();
}
